import { formatCount } from "./analytics-utils";

type Props = { ios: number; android: number };

const DeviceSplit = ({ ios, android }: Props) => {
  const total = ios + android;
  const iosPercent = total ? Math.round((ios / total) * 100) : 0;
  const rows = [
    { name: "iOS", count: ios, percent: iosPercent, swatch: "bg-action" },
    { name: "Android", count: android, percent: total ? 100 - iosPercent : 0, swatch: "bg-warning" },
  ];

  return (
    <div className="flex flex-col gap-4">
      <span className="font-mono text-2xl font-semibold tabular-nums text-fg">
        {formatCount(total)}
      </span>
      <div
        className="flex h-3.5 overflow-hidden rounded-full bg-surface-sunken"
        role="img"
        aria-label={rows.map((r) => `${r.name} ${r.percent}%`).join(", ")}
      >
        {rows.map((r) => (
          <div key={r.name} className={r.swatch} style={{ width: `${r.percent}%` }} />
        ))}
      </div>
      <dl className="flex flex-col gap-3 text-sm">
        {rows.map((r) => (
          <div key={r.name} className="flex items-center gap-2.5">
            <span className={`h-3 w-3 rounded-sm ${r.swatch}`} aria-hidden="true" />
            <dt className="flex-1 text-fg">{r.name}</dt>
            <dd className="font-mono font-semibold tabular-nums text-fg">{formatCount(r.count)}</dd>
            <dd className="w-11 text-right font-mono tabular-nums text-fg-muted">{r.percent}%</dd>
          </div>
        ))}
      </dl>
    </div>
  );
};

export default DeviceSplit;
